var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#2EB922"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9929 26.495C53.7722 26.9617 53.6448 27.4777 53.2581 27.8556C53.1667 27.9452 53.0876 28.0472 52.9962 28.1386C46.3833 34.7532 39.7704 41.3661 33.1584 47.9808C32.2918 48.8474 31.2828 49.1699 30.0901 48.7982C29.6225 48.6531 29.2367 48.3728 28.8948 48.0309C25.5954 44.7332 22.2933 41.4391 19.001 38.1335C17.6773 36.8037 17.7837 34.8824 19.24 33.7583C20.2938 32.9445 21.9013 32.9612 23.0782 34.1503C25.6042 36.7 28.1539 39.226 30.6816 41.7739C30.9295 42.0244 31.049 42.0446 31.3109 41.7819C37.1882 35.887 43.0768 30.0045 48.9602 24.1158C49.8242 23.251 50.8235 22.888 52.0179 23.2686C53.034 23.5929 53.643 24.3154 53.9181 25.334C53.9348 25.3964 53.9041 25.4799 53.992 25.5124C53.9929 25.8403 53.9929 26.1681 53.9929 26.495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e6b26ee13d3f96af6b1e110f71d0a731.svg";
export { ForwardRef as ReactComponent };